
export default {
  data() {
    return {
      showTooltip: false,
      checked: false
    };
  },
   watch:{
    checked(newVal) {
      localStorage.setItem('checkOption', newVal);
      this.$emit('handleChange',newVal);
    },
   },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    const bol = JSON.parse(localStorage.getItem('checkOption'))
    this.checked = bol;
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    toggleTooltip() {
      this.showTooltip = !this.showTooltip;
    },
    handleClickOutside(event) {
      if (
        this.showTooltip &&
        this.$refs.tooltipBox &&
        !this.$el.contains(event.target)
      ) {
        this.showTooltip = false;
      }
    }
  }
};
